import { EVENTS, handleMessage, initEvents } from "@/__main__/ipc-core.mjs";
import eventBus from "@/app/app-event-bus.mjs";

export const EVENT_OVERLAY_VISIBILITY = "EVENT_OVERLAY_VISIBILITY";

export interface OverlayVisibility {
  game: string;
  visible: boolean;
  hasWebOverlay?: boolean;
  webOverlays?: string[];
  trigger: string;
}

// TODO: refactor, wrong place!!! do not add more here!
// move to IPC init
(async () => {
  await initEvents;
  handleMessage(EVENTS.OVERLAY_VISIBILITY, (v) =>
    eventBus.emit(EVENT_OVERLAY_VISIBILITY, v),
  );
})();
